import { PhoneInputController } from "@/src/components/PhoneInputController/PhoneInputController";
import { APPLY_ONLINE_FIELD_RULES, ApplyOnlineOptionsConst } from "@/src/constants/apply-online";
import { IFormApplicationProps } from "@/src/types/applyOnline";
import ArrowSelect from "@/src/svg/applyOnline/ArrowSelectSvg";
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/src/store";

const FormApplicationFast: FC<IFormApplicationProps & { handleFocus?: () => void }> = ({ register, control, errors, handleFocus }) => {
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const allowedOffices = useSelector((state: RootState) => state.accessControl.allowedOffices);

  const officeOptions = useMemo(() => {
    if (hasFullCountryAccess) return ApplyOnlineOptionsConst.office;
    return allowedOffices
      .map((office) => ApplyOnlineOptionsConst.office.find((option) => option.value === office))
      .filter((option): option is (typeof ApplyOnlineOptionsConst.office)[number] => Boolean(option));
  }, [allowedOffices, hasFullCountryAccess]);

  return (
    <div className="form-application-fast">
      <div className="form-application-header">
        <h1 className="form-application-header-title">Quick Application</h1>
        {(errors.fullname || errors.office || errors.phone || errors.email) && (
          <span className="form-application-header-error">One of the fields contains an error!</span>
        )}
      </div>
      <div className="form-application-body">
        <div className="form-application-body-field fullname">
          <div className="form-application-body-field-label">
            <label htmlFor="apply-online-fullname">
              Full Name<span>*</span>
            </label>
            <div className="form-application-body-field-label-line"></div>
          </div>
          <input
            id="apply-online-fullname"
            className="form-application-body-input fullname"
            type="text"
            {...register("fullname", APPLY_ONLINE_FIELD_RULES.fullname)}
            onFocus={handleFocus}
          />
        </div>
        <div className="form-application-body-select office">
          <select
            id="apply-online-office"
            className="form-application-body-input select"
            {...register("office", APPLY_ONLINE_FIELD_RULES.office)}
            onFocus={handleFocus}
          >
            {officeOptions.map(({ value, label, disabled }) => (
              <option key={value} value={value} disabled={disabled}>
                {label}
              </option>
            ))}
          </select>
          <ArrowSelect />
        </div>
        <div id="apply-online-phone" className="form-application-body-input-phone-wrapper">
          <PhoneInputController name="phone" control={control} rules={APPLY_ONLINE_FIELD_RULES.phone} onFocus={handleFocus} />
        </div>
        <div className="form-application-body-field email">
          <div className="form-application-body-field-label">
            <label htmlFor="apply-online-email">
              Email<span>*</span>
            </label>
            <div className="form-application-body-field-label-line"></div>
          </div>
          <input
            id="apply-online-email"
            className="form-application-body-input email"
            type="email"
            {...register("email", APPLY_ONLINE_FIELD_RULES.email)}
            onFocus={handleFocus}
          />
        </div>
      </div>
    </div>
  );
};

export default FormApplicationFast;
